import axios from "axios";
import { JSON_CONTENT_FORM_CONFIG } from "../Config";
import { getJSONContentFormConfig } from "../Config";

export const listTarget = async (page = 1, perPage = 18, userIds = []) => {
  let params = `page=${page}&page_size=${perPage}`;
  if (userIds.length > 0) params += `&user_ids=${JSON.stringify(userIds)}`;
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/targets/list-targets/?${params}`,
      JSON_CONTENT_FORM_CONFIG
    );
    return res.data;
  } catch {
    return {
      success: false,
    };
  }
};

export const getTargetDetail = async (orderId) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/orders/detail/${orderId}/`,
      JSON_CONTENT_FORM_CONFIG
    );
    return res.data;
  } catch {
    return {
      success: false,
    };
  }
};

export const removeTarget = async (orderId, lineId) => {
  try {
    const jsonConfig = getJSONContentFormConfig();
    const res = await axios.delete(
      `${process.env.REACT_APP_API_BASE_URL}/orders/remove-line/${orderId}/${lineId}/`,
      jsonConfig
    );
    return res.data;
  } catch {
    return {
      success: false,
    };
  }
};
